import {
  AUTH_SIGN_IN,
  AUTH_SIGN_UP,
  AUTH_LOG_OUT,
  AUTH_SET_ERROR,
  AUTH_SET_PENDING,
  AUTH_SET_USERDATA,
  AUTH_SET_PRICETYPE,
  AUTH_SET_USERTYPE,
  AUTH_SET_USER_OPTION,
} from './actionTypes';

const defaultState = {
  isAuthenticated: false,
  userData: {},
  userOption: null,
  priceTypeList: [],
  userTypeList: [],
  pending: false,
  error: null,
};

export function auth(state = defaultState, action) {
  const { type, payload } = action;

  switch (type) {
    case AUTH_SIGN_IN:
      localStorage.setItem('token', JSON.stringify({ refresh: payload.refresh, access: payload.access }));
      return {
        ...state,
        pending: false,
        isAuthenticated: true,
        userData: { ...payload },
        error: null,
      };
    case AUTH_SET_USERTYPE:
      return { ...state, userTypeList: payload };
    case AUTH_SET_USER_OPTION:
      return { ...state, userOption: payload };
    case AUTH_SIGN_UP:
      return {
        ...state,
        pending: false,
        error: null,
      };

    case AUTH_LOG_OUT:
      localStorage.clear();
      return defaultState;

    case AUTH_SET_ERROR:
      return {
        ...state,
        pending: false,
        error: payload,
      };

    case AUTH_SET_PENDING:
      return {
        ...state,
        pending: payload,
      };

    case AUTH_SET_USERDATA:
      return {
        ...state,
        userData: payload,
      };

    case AUTH_SET_PRICETYPE:
      return {
        ...state,
        priceTypeList: payload,
      };

    default:
      return state;
  }
}
